import { useEffect, useState } from 'react';
import { Modal, IconButton } from '@fluentui/react';
import { Text } from '@fluentui/react';
import newsDataJson from '../../assets/news-data.json';

import styles from "./WhatsNewModal.module.css";

interface Props {
    viewed: boolean;
    onDismiss: () => void;
};

interface NewsItem {
    id: number;
    title: string;
    description: string;
};

interface NewsData {
    versionNumber: number;
    versionName: string;
    date: string;
    features: NewsItem[];
};

export const WhatsNewModal = ({ viewed, onDismiss }: Props) => {
    const [newsData, setNewsData] = useState<NewsData[]>([]);

    useEffect(() => {
        // Sort the data by date, versionNumber, and feature id
        const sortedData = [...newsDataJson].sort((a: NewsData, b: NewsData) => {
            const dateComparison = new Date(b.date).getTime() - new Date(a.date).getTime();
            if (dateComparison !== 0) {
                return dateComparison;
            } else {
                const versionComparison = b.versionNumber - a.versionNumber;
                if (versionComparison !== 0) {
                    return versionComparison;
                } else {
                    // Sort features by id
                    a.features.sort((a: NewsItem, b: NewsItem) => b.id - a.id);
                    b.features.sort((a: NewsItem, b: NewsItem) => b.id - a.id);
                    return 0;
                }
            }
        });
        setNewsData(sortedData);
    }, []);

    if (viewed) {
        return null;
    };

    return (
        <Modal
            isOpen={!viewed}
            onDismiss={onDismiss}
            containerClassName={styles.modalContainer}>
            <div className={styles.titleBlock}>
                <Text variant="xLarge" className={styles.title}>What's New</Text>
                <IconButton
                    className={styles.closeButton}
                    iconProps={{ iconName: 'Cancel' }}
                    ariaLabel="Close modal"
                    onClick={onDismiss}
                />
            </div>
            <div className={styles.contentBlock}>
                {newsData.map(version => (
                    <div key={version.versionNumber} className={styles.newsVersion}>
                        <Text variant="xLarge">
                            {version.versionName} - {new Date(version.date).toLocaleDateString('en-AU', { year: 'numeric', month: 'long', day: 'numeric' })}
                        </Text>
                        <br />
                        {version.features.map(feature => (
                            <div key={feature.id} className={styles.newsFeature}>
                                <Text variant="large" className={styles.newsFeatureTitle}>{feature.title}</Text>
                                <Text>{feature.description}</Text>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </Modal>
    );
};